import { useCallback, useEffect, useState } from 'react';

export const useCountdownTimer = (
  initialCount: number = 30
): {
  counter: number;
  isActive: boolean;
  start: () => void;
  stop: () => void;
} => {
  const [counter, setCounter] = useState(initialCount);
  const [isActive, setIsActive] = useState(false);

  const start = useCallback(() => {
    setCounter(initialCount);
    setIsActive(true);
  }, [initialCount]);

  const stop = useCallback(() => {
    setIsActive(false);
    setCounter(initialCount);
  }, [initialCount]);

  useEffect(() => {
    let interval: ReturnType<typeof setTimeout> | null = null;

    if (isActive && counter > 0) {
      interval = setInterval(() => {
        setCounter((prev) => {
          if (prev <= 1) {
            setIsActive(false);

            return initialCount;
          }

          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isActive, counter, initialCount]);

  return { counter, isActive, start, stop };
};
